import { filterZeroArrays, empty } from '@/lib/utils'
export default {
  computed: {
    progressStats () {
      const stats = { total: 0, passed: 0 }
      // Degree
      if (this.savedSchool.bachelors_degree_required) {
        stats.total += 1

        if (this.checkDegreeCompleted) {
          stats.passed += 1
        }
      }

      if (this.savedSchool.gpa_minimum_required) {
        stats.total += 1


        if (this.hasCompletedGPARequirement) {
          stats.passed += 1
        }
      }

      // Healthcare Exp
      if (
        this.savedSchool.healthcare_experience_required ||
        this.savedSchool.healthcare_experience_community_service ||
        this.savedSchool.cpr ||
        this.savedSchool.basic_life_support ||
        this.savedSchool.acls
      ) {
        if (this.savedSchool.healthcare_experience_required) {
          stats.total += 1

          if (this.hasHealthCareExperience) {
            stats.passed += 1
          }
        }

        if (!empty(this.savedSchool.healthcare_experience_community_service_hours)) {
          stats.total += 1
          if (this.totalCommunityServiceHours >= this.minCommunityServiceHours ) {
            stats.passed += 1
          }
        }

        if (this.savedSchool.cpr === true || this.savedSchool.basic_life_support === true || this.savedSchool.acls === true) {
          stats.total += 1
          if (!(this.totalRequiredCertifications.length - this.completedCertifications > 0)) {
            stats.passed += 1
          }
        }
      }

      if (this.savedSchool.letter_of_recommendation_required) {
        stats.total += 1
        if (this.hasRequiredLORs) {
          stats.passed += 1
        }
      }

      if (this.savedSchool.pa_shadowing_required) {
        stats.total += 1
        if (this.hasPAShadowingHours) {
          stats.passed += 1
        }
      }

      if (this.savedSchool.gre_required) {
        stats.total += 1
        if (this.greScoreCondition) {
          stats.passed += 1
        }
      }

      if (this.savedSchool.casper_accepted) {
        stats.total += 1
        if (this.hasCasperExam) {
          stats.passed += 1
        }
      }
       // PA-CAT
       if (this.savedSchool.pacat_required) {
        stats.total += 1
        if (this.hasPacatExam ) {
          stats.passed += 1
        }
      }

      if (filterZeroArrays(this.savedSchool.required_courses).length) {
        stats.total += 1
        if (this.usersRemaingingPrerequisites.length === 0) {
          stats.passed += 1
        }
      }

      if (filterZeroArrays(this.savedSchool.optional_courses_group).length) {
        stats.total += 1
        if (this.savedSchool.optional_courses_group.length <= this.allOptionalCourses.length) {
          stats.passed += 1
        }
      }

      if (filterZeroArrays(this.savedSchool.required_category_courses).length) {
        stats.total += 1
        if (this.savedSchool.required_category_courses.length - this.usersRemaingingCourseCat.length === 0) {
          stats.passed += 1
        }
      }

      if (this.needsInternaltionalChecks) {
        stats.total += 1
        if (this.clearInternationalChecks) {
          stats.passed += 1
        }
      }
      return stats
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/requirementchecks/overallmixin.js